export default "__VITE_ASSET__cI3VDFaC__"